export default __webpack_public_path__ + "static/media/scienceLogo.bb6cd4ed.png";